import React, { useDebugValue, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { MentorTopicSlice, getEntityMentorTopic } from 'app/entities/mentor-topic/mentor-topic.reducer';
import AdminTabs from './AdminTabs';
import NewsFeedPage from './newsFeed';
import InspirationAdminPage from './InspirationAdmin';
import UsersAdmin from './UsersAdmin';
import { Row } from 'reactstrap';
import UsersAdminDashoard from './AdminDashboard';
import Topic from './topic';
import PointAllocationSystem from './point-allocation-system';
import PointDetails from './point-details';
import Announcement from './announcement/announcement';
import AnnouncementRoutes from './announcement';
import AnnouncementPage from './announcement/announacements';
import InterviewsAdmin from './Interview-admin';
import Listing from './earn-more-points/Listing';
import ApprovalAdmin from './ApprovalAdmin';
import HousingUpdate from './housing-update';
import GoodGovernanceUpdate from './good-governance-update';

interface StateType {
  tab: string;
  // Define other properties as needed
}

export const AdminProfile = props => {
  const dispatch = useAppDispatch();
  const { id } = useParams<'id'>();
  const [activeTab, setActiveTab] = useState('admindashboard');
  const location = useLocation();

  useEffect(() => {
    const tabData = location?.state as StateType | undefined;
    if (tabData) {
      const tabActive = tabData.tab;
      setActiveTab(tabActive);
    }
  }, []);
  return (
    <>
      <div className="container">
        <AdminTabs
          tab1Content={<UsersAdminDashoard />}
          tab2Content={<UsersAdmin />}
          tab3Content={<NewsFeedPage />}
          tab4Content={<InspirationAdminPage />}
          tab5Content={<Topic />}
          tab6Content={<PointDetails />}
          tab7Content={<AnnouncementPage />}
          tab8Content={<InterviewsAdmin />}
          tab9Content={<Listing />}
          tab10Content={
            <ApprovalAdmin
              apiUrl="api/housings"
              title="Housing"
              renderForm={({ onDone }) => <HousingUpdate housing={null} handleSubmit={onDone} showView="add" />}
            />
          }
          tab11Content={
            <ApprovalAdmin
              apiUrl="api/good-governanaces"
              title="Good Governance"
              renderForm={({ onDone }) => <GoodGovernanceUpdate governance={null} handleSubmit={onDone} showView="add" />}
            />
          }
          currentActiveTab={activeTab}
        />
      </div>
    </>
  );
};

export default AdminProfile;
